import styles from './GridView.module.scss'
import { CardGroup, CardOverlayGroup } from '~modules'
import { GridViewProps } from 'types/calendar'

const GridView = ({ cardGroup, cardGroupOverlay }: GridViewProps) => {
  return (
    <>
      {cardGroupOverlay && <CardOverlayGroup {...cardGroupOverlay} hasFullWidth />}
      {cardGroup && (
        <div className={styles['card-group-gutter-offset']}>
          <CardGroup {...cardGroup} />
        </div>
      )}
    </>
  )
}

export default GridView
